/**
 * Zeitraeume der Reflexionen (V-11, F-14): Wochen- und Monatskennungen.
 * Reine Kalenderrechnung ohne Zeitzone.
 */
import { addDays, addMonths, endOfMonth, startOfWeek } from '@/lib/datetime';
import type { LocalDate } from '@/domain/types';

/** `'2026-09'` */
export function monatKey(date: LocalDate): string {
  return date.slice(0, 7);
}

export function monatsBereich(key: string): { von: LocalDate; bis: LocalDate } {
  const von = `${key}-01`;
  return { von, bis: endOfMonth(von) };
}

export function monatVerschieben(key: string, n: number): string {
  return monatKey(addMonths(`${key}-01`, n));
}

/** Montag der ISO-Woche `'2026-W39'` - der 4. Januar liegt immer in KW 1. */
export function montagVonWoche(key: string): LocalDate | null {
  const m = /^(\d{4})-W(\d{2})$/.exec(key);
  if (!m) return null;
  return addDays(startOfWeek(`${m[1]}-01-04`), (Number(m[2]) - 1) * 7);
}

const MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

/** `'September 2026'` */
export function monatName(key: string): string {
  return `${MONATE[Number(key.slice(5, 7)) - 1]} ${key.slice(0, 4)}`;
}

/**
 * Unter welchem Datum die Lebensrad-Bewertung eines Monats gespeichert wird
 * (V-07): im laufenden Monat heute, fuer vergangene Monate der Monatsletzte.
 * Kuenftige Monate lassen sich nicht bewerten (`null`).
 */
export function lebensradDatum(monat: string, heute: LocalDate): LocalDate | null {
  if (monat === monatKey(heute)) return heute;
  if (monat > monatKey(heute)) return null;
  return monatsBereich(monat).bis;
}
